import { render, staticRenderFns } from "./WeFixRepairUSHome.vue?vue&type=template&id=28147a73&"
import script from "./WeFixRepairUSHome.vue?vue&type=script&lang=js&"
export * from "./WeFixRepairUSHome.vue?vue&type=script&lang=js&"
import style0 from "./WeFixRepairUSHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports